import { env } from "."

const ru = [
    {
        id: 1,
        title: 'Правила игры',
        text: 'Цель игры – в наборе покерной комбинации карт более сильной, чем у дилера. Для игры используется одна стандартная колода из 52-х карт. Игрок делает ставку Анте (Ante) в пределах минимума и максимума стола и получает 5 карт. У дилера тоже 5 карт, одна из них открыта. За столом может играть только один игрок. Игрок может играть на один бокс или два бокса равными ставками. Если игрок, посмотрев свои карты, отказывается от игры, ставка Анте проигрывает. За сумму, равную ставке Анте, игрок может обменять от двух до пяти карт или докупить шестую карту. После этого игрок принимает решение – продолжать игру или нет. Если игрок принял решение играть, то он должен поставить ставку, равную двум Анте. Если игрок принимает решение не играть (Пас) – теряет при этом ставку Анте. После того, как игроки приняли решение, дилер открывает свои карты. Если у дилера есть игра, он сравнивает ее с покерными комбинациями игроков. У дилера есть игра, если в его картах есть комбинация Туз – Король или выше. Если у дилера нет игры – оплачивается только ставка Анте 1:1. Если у игрока комбинация старше, чем у дилера, оплачивается только ставка Бет в соответствии с таблицей выплат. Кроме выигрышной комбинации в картах игрока может быть образована вторая комбинация, которая также оплачивается. Вторая комбинация должна включать в себя хотя бы одну карту, не входящую в основную комбинацию. При комбинации Стрит оплачивается Стрит и Пара, а не два Стрита. Туз-Король и пара не является двумя парами. Если игровая комбинация игрока ниже, чем у дилера, то его ставки Анте и Бет проигрывают.',
        content:
            <div className="rule-content">
                <p><b>Ultimate Texas Hold’em – это разновидность Texas Hold’em покера.</b><br /><br />
                    Цель игры – в наборе покерной комбинации из пяти карт более сильной, чем у дилера, используя свои две карты и пять общих карт. Дилер также использует две свои и пять общих карт.</p>
                <br />
                <p>Для игры используется одна стандартная колода из 52-х карт.</p>
                <br />
                <p>Игрок делает ставку Анте (Ante) в пределах минимума и максимума стола, при этом автоматически размещается ставка Блаинд (Blind) равная ставке Анте. </p>
                <br />
                <p>Игрок на каждый бокс получает по две открытые карты, у дилера две закрытые карты. Увидев свои карты, игрок может поставить ставку Бет (Bet) в размере 3-х или 4-х Анте, в этом случае игрок ждет пока дилер раздаст пять общих карт и сравнит комбинации. Либо игрок может на данном этапе не принимать решение – Чек (Check). Далее дилер раздает три общие карты Флоп (Flop). Если игрок на предыдущем этапе выбрал Чек, то увидев уже пять карт может поставить ставку Бет в размере 1-го или 2-х Анте, в этом случае игрок ждет пока дилер раздаст еще две общие карты и сравнит комбинации, либо также выбрать Чек. Далее дилер раздает еще две общие карты Терн и Ривер.</p>
                <p>Если игрок на предыдущем этапе выбрал Чек, то увидев уже семь карт может поставить ставку Бет в размере 1-го Анте, либо выбрать Пас. При выборе Пас ставки Анте и Блайнд проигрывают.</p>
                <br />
                <p>Далее открываются карты дилера и сравниваются комбинации.
                    У дилера есть игра, если в его комбинации есть две Двойки и выше.
                    Если у дилера есть игра, а комбинация старше, чем у игрока, то ставки Анте, Блайнд и Бет проигрывают. Если у дилера нет игры, а комбинация старше, чем у игрока, то ставка Анте возвращается, ставки Блайнд и Бет проигрывают.</p>

                <p>Если у игрока комбинация старше, чем у дилера и при этом у дилера есть игра, то ставки Анте и Бет оплачиваются 1:1, Ставка Блайнд оплачивается в соответствии с таблицей выплат. Если у игрока комбинация старше, чем у дилера и при этом у дилера нет игры, то ставка Анте возвращается, а Бет оплачиваются 1:1, Ставка Блайнд оплачивается в соответствии с таблицей выплат.
                </p>

                <p>Если комбинации у игрока и дилера одинаковые, ставки возвращаются - «Stand off» (ничья).</p>

                <p>Максимальная выплата - выигрыш, который может быть выплачен на 1 бокс.</p>

                <br />

                <p>Таблица выплат по Blind:</p>

                <table className="rules-table two-rows">
                    <thead>
                        <tr>
                            <th className="strong">Комбинация</th>
                            <th className="strong">Выплата</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Остальные</td>
                            <td>Ничья</td>
                        </tr>
                        <tr>
                            <td>Стрит</td>
                            <td>1:1</td>
                        </tr>
                        <tr>
                            <td>Флеш</td>
                            <td>3:2</td>
                        </tr>
                        <tr>
                            <td>Фулл-хаус</td>
                            <td>3:1</td>
                        </tr>
                        <tr>
                            <td>Каре</td>
                            <td>10:1</td>
                        </tr>
                        <tr>
                            <td>Стрит</td>
                            <td>50:1</td>
                        </tr>
                        <tr>
                            <td>Рояль-флеш</td>
                            <td>400:1</td>
                        </tr>
                    </tbody>
                </table>

                <p>Таблица для быстрого определения выигрыша или проигрыша:</p>

                <table className="rules-table">
                    <thead>
                        <tr>
                            <th className="strong">Старшая комбинация</th>
                            <th className="strong">«Игра» у дилера</th>
                            <th className="strong">БЛАЙНД</th>
                            <th className="strong">АНТЕ</th>
                            <th className="strong"> ВЕТ</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>ИГРОК</td>
                            <td>Есть игра</td>
                            <td>Выигрыш</td>
                            <td>Выигрыш</td>
                            <td>Выигрыш</td>
                        </tr>
                        <tr>
                            <td>ИГРОК</td>
                            <td>Нет игры</td>
                            <td>Выигрыш</td>
                            <td>Стей</td>
                            <td>Выигрыш</td>
                        </tr>
                        <tr>
                            <td>ДИЛЕР</td>
                            <td>Есть игра</td>
                            <td>Проигрыш</td>
                            <td>Проигрыш</td>
                            <td>Проигрыш</td>
                        </tr>
                        <tr>
                            <td>ДИЛЕР</td>
                            <td>Нет игры</td>
                            <td>Проигрыш</td>
                            <td>Стей</td>
                            <td>Проигрыш</td>
                        </tr>
                        <tr>
                            <td>ОДИНАКОВАЯ</td>
                            <td>Есть/Нет</td>
                            <td>Стей</td>
                            <td>Стей</td>
                            <td>Стей</td>
                        </tr>
                    </tbody>
                </table>

                <p>Также игрок может поставить дополнительную ставку Trips.<br />
                    Ставка Trips выиграет если у игрока есть комбинация три одинаковых карты «Тройка» и выше и оплачивается в соответствии с таблицей выплат. В остальных случаях ставка Trips проигрывает.</p>
                <br />

                <p>Таблица выплат по Trips:</p>

                <table className="rules-table two-rows">
                    <thead>
                        <tr>
                            <th className="strong">Комбинация</th>
                            <th className="strong">Выплата</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Tройка</td>
                            <td>3:1</td>
                        </tr>
                        <tr>
                            <td>Стрит</td>
                            <td>4:1</td>
                        </tr>
                        <tr>
                            <td>Флеш</td>
                            <td>5:1</td>
                        </tr>
                        <tr>
                            <td>Фулл-хаус</td>
                            <td>8:1</td>
                        </tr>
                        <tr>
                            <td>Каре</td>
                            <td>40:1</td>
                        </tr>
                        <tr>
                            <td>Стрит</td>
                            <td>100:1</td>
                        </tr>
                        <tr>
                            <td>Рояль-флеш</td>
                            <td>200:1</td>
                        </tr>
                    </tbody>
                </table>

            </div>
    },
    {
        id: 2,
        title: 'Выигрышные руки',
        content:
            <div className="rule-content">
                - Отдельные карты перечислены по убыванию: туз (старший или младший), король, дама, валет, 10, 9, 8, 7, 6, 5, 4, 3 и 2.
                Туз может быть самой старшей картой в стрейте из туза, короля, дамы, валета и 10 или самой младшей в стрейте из 5, 4, 3, 2 и туза.
                Возможные руки в порядке убывания:
                <br /><br />
                Флеш-рояль - это стрейт-флеш из туза, короля, дамы, валета и 10 одной масти. В случае НИЧЬЕЙ игроку возвращается его исходная ставка, а игра заканчивается.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/royalFlash.svg`} alt="chips" />
                <br /><br />
                Стрейт-флеш - это рука, в состав которой входит пять последовательных карт одной масти; например: девятка, восьмерка, семерка, шестерка и пятерка, все червовой масти. Два стрейт-флеша сравниваются по самой старшей карте в каждом из них. В случае НИЧЬЕЙ игроку возвращается его исходная ставка, а игра заканчивается.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/streetFlash.svg`} alt="chips" />
                <br /><br />
                Каре - это рука, в состав которой входит четыре карты одного ранга и любая другая
                карта. Например, четыре туза в руке - это и есть каре. Четверки из карт более высокого
                ранга старше четверок из карт более низкого ранга.                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/fourofakind.svg`} alt="chips" />
                <br /><br />
                Фулл-хаус - это рука, в состав которой входят три карты
                одинакового ранга и пара из карт другого ранга, например: три
                короля и две шестерки. Из двух рук с фулл-хаусом старшей является та, в состав
                которой входят три карты более высокого ранга.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/fullhouse.svg`} alt="chips" />
                <br /><br />
                Флеш - это рука, в состав которой входят любые пять карт одной масти в любой
                последовательности, например: пять карт трефовой масти. Два флеша сравниваются
                как руки со старшей картой; для определения победителя сравнивается самая старшая
                карта в каждой из рук. Если в обеих руках совпадают карты самого высокого ранга,
                сравнивается вторая самая высокая по рангу карта. И так до тех пор, пока не будет
                определен победитель. В случае НИЧЬЕЙ игроку возвращается ставка Анте и Бет, а игра
                заканчивается.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/flash.svg`} alt="chips" />
                <br /><br />
                Стрейт - это рука, в состав которой входят пять последовательных карт как минимум
                двух разных мстей, например: девятка, восьмерка, семерка, шестерка и пятерка двух
                или более мастей. Два стрейта сравниваются по самой старшей карте в каждой из рук.
                Два стрейта с одинаковыми старшими картами имеют одинаковую ценность,
                поскольку масти в сравнении не участвуют. В случае НИЧЬЕЙ игроку возвращается
                ставка Анте и Бет, а игра заканчивается.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/street.svg`} alt="chips" />
                <br /><br />
                Тройка - это рука, в состав которой входят три карты одного ранга и две неодинаковые
                карты другого ранга. Например, у игрока с тремя королями в руке есть тройка.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/threeofakind.svg`} alt="chips" />
                <br /><br />
                Две пары - это рука, в состав которой входят две карты одного ранга, две карты
                другого ранга (которые соответствуют друг другу, но не первой паре) и любая другая
                отличная от их рангов карта.<br />
                Примером является рука, в состав которой входят два туза и два короля. Для оценки
                двух рук с двумя парами сначала сравнивается самая высокая пара каждой из рук.
                Побеждает рука с самой высокой парой. Если в обеих руках имеется одинаковая по
                величине самая высокая пара, сравнивается вторая пара каждой из рук. Если в обеих
                руках имеются две равные пары, победитель определяется по следующей карте. В
                случае НИЧЬЕЙ игроку возвращается ставка Анте и Бет, а игра заканчивается.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/twopairs.svg`} alt="chips" />
                <br /><br />
                Пара - это рука, в состав которой входят две карты одного ранга (например: два
                короля) и три неодинаковые карты другого ранга.<br />
                Пара - эта самая слабая рука, которая может победить в игре. Пары из карт более
                высокого ранга побеждают пары из карт более низкого ранга. Если в двух руках
                имеется одинаковая пара, сравниваются следующие карты в порядке убывания. В
                случае НИЧЬЕЙ игроку возвращается ставка Анте и Бет, а игра заканчивается.                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/pair.svg`} alt="chips" />
                <br />
            </div>
    },
    {
        id: 4,
        title: 'Делайте ставки',
        content:
            <div className="rule-content">
                Панель «ЛИМИТЫ СТАВОК» отображает минимальные и максимальные разрешенные лимиты ставок за столом, которые могут время от времени меняться. Откройте «Лимиты ставок», чтобы проверить свои текущие лимиты.
                <br /><br />
                Ultimate Texas Hold’em 1 -  1 000 $
                <br /><br />
                Для участия в игре вам потребуется достаточное количество средств, необходимое для покрытия ставок. Ваш текущий БАЛАНС отображается на экране.
                <br /><br />
                Ваши средства - БАЛАНС 100 000 $
                <br /><br />
                Индикатор «ОТОБРАЖЕНИЕ ФИШЕК» позволяет выбирать достоинство каждой фишки, которую захотите разместить в виде ставки. Для выбора доступны только те фишки, номинал которых может быть покрыт вашим текущим балансом.
                <br /><br />
                <img className='rule-img' src={`${env.mediapoint}/images/rules/chips.svg`} alt="chips" />
                <br /><br />
                После выбора фишки сделайте ставку, нажав на соответствующее место для ставки на игровом столе. При каждом нажатии на место для ставок сумма вашей ставки увеличивается на стоимость выбранной фишки или до максимально допустимого лимита для выбранного вами типа ставки. После размещения максимально допустимого лимита ставки дополнительные средства не принимаются, а над вашей ставкой появится сообщение с уведомлением о размещении максимальной ставки.
                <br />
                <img className='rule-img-big widget' src={`${env.endpoint}/images/rates.png`} alt="bet-ante" />
                <br /><br />
                ПРИМЕЧАНИЕ: Пожалуйста, не сворачивайте окно браузера и не открывайте другие вкладки в своем браузере, пока активно время размещения ставок и ставки размещаются на столе. Такие действия могут быть расцедены как выход из игры, и, следовательно, ваши ставки будут отклонены в этом раунде игры.
                <br /><br />
                Кнопка «ПОВТОРИТЬ» позволяет повторить все ставки из предыдущего раунда игры. Эта кнопка остается активной до тех пор, пока не будет размещена первая фишка.
                <br /><br />
                <img className='rule-button-img' src={`${env.mediapoint}/images/rules/repeat.svg`} alt="btn" />
                <br /><br />
                Кнопка «УДВОИТЬ» (2×) становится доступной после размещения ставки. С каждым щелчком/нажатием все ваши ставки удваиваются вплоть до максимального предела. Обратите внимание, что вам необходимо иметь достаточное количество средств на счете для удвоения ВСЕХ ваших размещенных ставок.
                <br /><br />
                <img className='rule-button-img' src={`${env.mediapoint}/images/rules/double.svg`} alt="btn" />
                <br /><br />
                Кнопка «ОТМЕНА» позволяет удалить последнюю размещенную ставку.
                <br /><br />
                Повторное нажатие кнопки «ОТМЕНА» позволяет отменить ставки по одной в обратном порядке их размещения. Чтобы удалить все свои ставки, удерживайте нажатой кнопку «ОТМЕНА».
                <br /><br />
                <img className='rule-button-img' src={`${env.mediapoint}/images/rules/cancel.svg`} alt="btn" />
                <br /><br />
                Индикатор «ОБЩАЯ СТАВКА» отображает общую сумму ставок, размещенных в текущем раунде.
                <br /><br />
                <img className='rule-img border' src={`${env.mediapoint}/images/rules/totalBet.svg`} alt="total" />
                <br /><br />
                Примите решение
                <br /><br />
                После раздачи ваших карт появится ваша комбинация карт и окно
                <br /><br />
                <img className='rule-img-big widget' src={`${env.endpoint}/images/game.webp`} alt="game" />
                <br /><br />
                Чтобы перейти на следующий раунд надо нажать на окно ЧЕК
                <br /><br />
                <img className='rule-img-big' src={`${env.endpoint}/images/check-btn.png`} alt="sixth" />
                <br /><br />
                Вы должны решить, что нажать: «BET» для продолжения раунда игры или «ПАС» для завершения раунда игры с потерей размещенных ставок.
                <br /><br />
                <img className='rule-img-big' src={`${env.endpoint}/images/bet-pass.png`} alt="btn" />
                <br /><br />
                При нажатии на кнопку «BET» вы продолжаете играть и делаете ставку «BET», Ставка «BET» будет автоматически размещена в месте для ставки «BET».
                <br /><br />
                После щелчка/нажатия кнопки «ПАС» вы потеряете свою ставку АНТЕ.
                Вы сможете наблюдать за ходом игры, но не сможете в ней участвовать. Чтобы сделать новые ставки, вам придется дождаться следующего раунда.
                <br />
            </div>
    },
    {
        id: 6,
        title: 'Номер игры',
        content:
            <div className="rule-content">
                Каждый раунд игры идентифицируется уникальным НОМЕРОМ ИГРЫ.
                <br /><br />
                <img className='rule-img border' src={`${env.endpoint}/images/game-number.png`} alt="number" />
                <br /><br />
                Пожалуйста, используйте этот номер (или сделайте снимок экрана с номером игры), если вы хотите обратиться в Службу поддержки с вопросами относительно определенного раунда.
            </div>
    },
    {
        id: 7,
        title: 'Звук',
        content:
            <div className="rule-content">
                Кнопка «ЗВУК» включает/выключает все звуки игры и голоса.
                Примите к сведению, что в случае смены стола все звуки включатся автоматически.
                <br /><br />
                <img className='rule-img' src={`${env.mediapoint}/images/music-on.png`} alt="chips" />
                <br /><br />
                Вы можете изменить настройки звука, нажав кнопку «НАСТРОЙКИ» и выбрав вкладку ЗВУК,
            </div>
    },
    {
        id: 8,
        title: 'История игр',
        content:
            <div className="rule-content">
                С помощью кнопки «ИСТОРИЯ» можно открыть окно, в котором будут отображены все сыгранные вами раунды игры и их результаты.
                <br /><br />
                <img className='rule-img' src={`${env.mediapoint}/images/menu/history.png`} alt="chips" />
                <br /><br />
                Вы можете просматривать свою игровую активность с помощью . следующего:
                <br /><br />
                • ИСТОРИЯ УЧЕТНОЙ ЗАПИСИ - отображает всю историю вашей учетной записи в виде списка дат, игр, сумм ставок и выплат.
                <br /><br />
                Последний завершенный раунд отображается в самом верху списка.
                <br /><br />
                • ИСТОРИЯ ИГР -- после щелчка/нажатия на определенную игру в столбце ИГРА отображает вашу историю, связанную с определенной игрой.
            </div>
    },
    {
        id: 9,
        title: 'Действия в случае сбоя',
        content:
            <div className="rule-content">
                При сбоях в игре, игровой системе или процедуре игры раунд временно
                приостанавливается, а ведущий игры уведомляет об этом сервис-менеджера. Вы и
                другие игроки увидят сообщение в чате или всплывающее сообщение на экране о том,
                что данный вопрос рассматривается. Если менеджер сможет незамедлительно 2
                устранить ошибку, раунд игры продолжится, как обычно. В случае отсутствия
                возможности незамедлительного устранения раунд игры аннулируется, а изначальные
                ставки подлежат возмещению всем игрокам, принявшим в нем участие.            </div>
    },
    {
        id: 10,
        title: 'Политика отключения',
        content:
            <div className="rule-content">
                В случае отключения от игры до истечения времени для размещения ставок любые
                сделанные ставки признаются недействительными и возвращаются вам. В случае
                отключения после истечения времени для размещения ставок, сделанные ставки
                признаются действительными и разыгрываются без вашего участия. Результаты
                розыгрыша ставки можно посмотреть в окне «История» после повторного
                подключения.
            </div>
    }
]

const en = [
    {
        id: 1,
        title: 'Game Rules',
        text: "The goal of the game is to form a poker hand stronger than the dealer's. The game uses a standard deck of 52 cards. The player places an Ante bet within the table’s minimum and maximum limits and receives 5 cards. The dealer also gets 5 cards, one of which is face-up. Only one player can play at the table. The player can play with one or two boxes with equal bets. If the player folds after seeing their cards, the Ante bet is lost. For an amount equal to the Ante, the player can exchange two to five cards or buy a sixth card. Afterward, the player decides whether to continue playing. If the player chooses to play, they must place a bet equal to twice the Ante. If the player folds (Pass), they lose the Ante bet. After the players make their decisions, the dealer reveals their cards. If the dealer has a game, they compare it to the players' poker hands. The dealer qualifies if they have a hand with Ace-King or better. If the dealer does not qualify, only the Ante bet is paid 1:1. If the player's hand is stronger than the dealer's, only the Bet is paid according to the payout table. Apart from the winning hand, the player's cards may form a second combination, which is also paid. The second combination must include at least one card not part of the main hand. In the case of a Straight, both the Straight and Pair are paid, not two Straights. Ace-King and a Pair do not count as two pairs. If the player's hand is lower than the dealer's, both Ante and Bet bets are lost.",
        content: (
            <div className="rule-content">
                <p><b>Ultimate Texas Hold’em is a variant of Texas Hold’em poker.</b><br /><br />
                    The goal of the game is to form a five-card poker hand stronger than the dealer's, using your two cards and five community cards. The dealer also uses two of their own cards and the five community cards.
                </p>
                <p>A standard deck of 52 cards is used for the game.</p>

                <p>The player places an Ante bet within the table's minimum and maximum limits, and a Blind bet equal to the Ante is automatically placed.</p>

                <p>The player receives two open cards for each box, while the dealer has two face-down cards. After seeing their cards, the player may place a Bet equal to 3 or 4 times the Ante, in which case the player waits for the dealer to deal five community cards and compares hands. Alternatively, the player may choose to Check at this stage. Then the dealer deals three community cards (the Flop). If the player chose to Check earlier, they may place a Bet equal to 1 or 2 times the Ante after seeing five cards. The player then waits for the dealer to deal two more community cards and compare hands or may again choose to Check. The dealer then deals two more community cards (the Turn and the River).</p>

                <br />

                <p>If the player chose to Check earlier, after seeing seven cards, they can place a Bet equal to 1 Ante or choose to Fold. If they choose to Fold, the Ante and Blind bets lose.</p>

                <p>Then the dealer's cards are revealed, and hands are compared.
                    The dealer has a qualifying hand if their combination contains two Twos or higher.
                    If the dealer has a qualifying hand and their hand is stronger than the player's, the Ante, Blind, and Bet bets lose. If the dealer does not have a qualifying hand but their hand is stronger than the player’s, the Ante bet is returned, and the Blind and Bet bets lose.
                </p>

                <p>If the player's hand is stronger than the dealer’s and the dealer has a qualifying hand, the Ante and Bet are paid 1:1, and the Blind bet is paid according to the payout table. If the player's hand is stronger and the dealer does not have a qualifying hand, the Ante bet is returned, the Bet is paid 1:1, and the Blind bet is paid according to the payout table.</p>

                <p>If the player and dealer have identical hands, the bets are returned – "Stand off" (tie).</p>

                <p>The maximum payout is the winning amount that can be paid on one box.</p>

                <br />

                <p>Blind Payout Table:</p>

                <table className="rules-table two-rows">
                    <thead>
                        <tr>
                            <th className="strong">Combination</th>
                            <th className="strong">Payout</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Other</td>
                            <td>Push</td>
                        </tr>
                        <tr>
                            <td>Straight</td>
                            <td>1:1</td>
                        </tr>
                        <tr>
                            <td>Flush</td>
                            <td>3:2</td>
                        </tr>
                        <tr>
                            <td>Full House</td>
                            <td>3:1</td>
                        </tr>
                        <tr>
                            <td>Four of a Kind</td>
                            <td>10:1</td>
                        </tr>
                        <tr>
                            <td>Straight Flush</td>
                            <td>50:1</td>
                        </tr>
                        <tr>
                            <td>Royal Flush</td>
                            <td>400:1</td>
                        </tr>
                    </tbody>
                </table>

                <p>Quick Reference Table for Win/Loss Determination:</p>

                <table className="rules-table">
                    <thead>
                        <tr>
                            <th className="strong">Higher Hand</th>
                            <th className="strong">Dealer Qualifies</th>
                            <th className="strong">BLIND</th>
                            <th className="strong">ANTE</th>
                            <th className="strong">BET</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>PLAYER</td>
                            <td>Dealer Qualifies</td>
                            <td>Win</td>
                            <td>Win</td>
                            <td>Win</td>
                        </tr>
                        <tr>
                            <td>PLAYER</td>
                            <td>No Qualify</td>
                            <td>Win</td>
                            <td>Push</td>
                            <td>Win</td>
                        </tr>
                        <tr>
                            <td>DEALER</td>
                            <td>Dealer Qualifies</td>
                            <td>Loss</td>
                            <td>Loss</td>
                            <td>Loss</td>
                        </tr>
                        <tr>
                            <td>DEALER</td>
                            <td>No Qualify</td>
                            <td>Loss</td>
                            <td>Push</td>
                            <td>Loss</td>
                        </tr>
                        <tr>
                            <td>TIE</td>
                            <td>Qualify/No Qualify</td>
                            <td>Push</td>
                            <td>Push</td>
                            <td>Push</td>
                        </tr>
                    </tbody>
                </table>

                <p>The player may also place an additional Trips bet.<br />
                    The Trips bet wins if the player has three of a kind ("Trips") or higher and is paid according to the payout table. In all other cases, the Trips bet loses.</p>
                <br />

                <p>Trips Payout Table:</p>

                <table className="rules-table two-rows">
                    <thead>
                        <tr>
                            <th className="strong">Combination</th>
                            <th className="strong">Payout</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Three of a Kind</td>
                            <td>3:1</td>
                        </tr>
                        <tr>
                            <td>Straight</td>
                            <td>4:1</td>
                        </tr>
                        <tr>
                            <td>Flush</td>
                            <td>5:1</td>
                        </tr>
                        <tr>
                            <td>Full House</td>
                            <td>8:1</td>
                        </tr>
                        <tr>
                            <td>Four of a Kind</td>
                            <td>40:1</td>
                        </tr>
                        <tr>
                            <td>Straight Flush</td>
                            <td>100:1</td>
                        </tr>
                        <tr>
                            <td>Royal Flush</td>
                            <td>200:1</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    },
    {
        id: 2,
        title: 'Winning Hands',
        content: (
            <div className="rule-content">
                - Individual cards are ranked from highest to lowest: Ace (high or low), King, Queen, Jack, 10, 9, 8, 7, 6, 5, 4, 3, and 2.
                The Ace can be the highest card in a straight from Ace, King, Queen, Jack, and 10, or the lowest in a straight from 5, 4, 3, 2, and Ace.
                Possible hands in descending order:
                <br /><br />
                A Royal Flush is a straight flush from Ace, King, Queen, Jack, and 10 of the same suit. In case of a TIE, the player’s original bet is returned, and the game ends.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/royalFlash.svg`} alt="chips" />
                <br /><br />
                A Straight Flush consists of five consecutive cards of the same suit; for example: nine, eight, seven, six, and five, all hearts. Two straight flushes are compared by the highest card in each. In case of a TIE, the player’s original bet is returned, and the game ends.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/streetFlash.svg`} alt="chips" />
                <br /><br />
                Four of a Kind is a hand that contains four cards of the same rank and any other card. For example, four Aces in hand form a Four of a Kind. Higher-ranked fours are stronger than lower-ranked fours. <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/fourofakind.svg`} alt="chips" />
                <br /><br />
                A Full House consists of three cards of the same rank and a pair of cards of another rank, for example: three Kings and two sixes. Of two Full Houses, the one with three higher-ranked cards is stronger.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/fullhouse.svg`} alt="chips" />
                <br /><br />
                A Flush consists of any five cards of the same suit in any order, for example: five clubs. Two Flushes are compared by the highest card in each hand. If both hands have cards of the same highest rank, the second-highest card is compared. This process continues until a winner is determined. In case of a TIE, the Ante and Bet are returned, and the game ends.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/flash.svg`} alt="chips" />
                <br /><br />
                A Straight consists of five consecutive cards of at least two different suits, for example: nine, eight, seven, six, and five of two or more suits. Two Straights are compared by the highest card in each hand. Two Straights with the same highest card are of equal value, as suits are not considered in comparison. In case of a TIE, the Ante and Bet are returned, and the game ends.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/street.svg`} alt="chips" />
                <br /><br />
                Three of a Kind consists of three cards of the same rank and two unmatched cards of another rank. For example, a player with three Kings in hand has a Three of a Kind.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/threeofakind.svg`} alt="chips" />
                <br /><br />
                Two Pairs consist of two cards of one rank, two cards of another rank (which match each other but not the first pair), and any other card. <br />
                An example is a hand containing two Aces and two Kings. To evaluate two hands with two pairs, the highest pair in each hand is compared first. The hand with the higher pair wins. If both hands have the same highest pair, the second pair is compared. If both hands have two equal pairs, the winner is determined by the next card. In case of a TIE, the Ante and Bet are returned, and the game ends.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/twopairs.svg`} alt="chips" />
                <br /><br />
                A Pair consists of two cards of the same rank and three other unmatched cards of different ranks. For example, a player with two Aces in hand has a Pair. Two Pairs are compared by the highest pair in each hand. If both hands contain the same pair, the highest remaining card is compared. In case of a TIE, the Ante and Bet are returned, and the game ends.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/pair.svg`} alt="chips" />
                <br /><br />
                A High Card hand consists of any five cards that do not fit into the above categories. For example, the hand of an Ace, King, Jack, ten, and eight of at least two different suits is called an Ace High. Two High Card hands are compared by the highest card in each. If both hands have the same highest card, the next highest cards are compared. In case of a TIE, the Ante and Bet are returned, and the game ends.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/aceKing.svg`} alt="chips" />
            </div>
        )
    },
    {
        id: 4,
        title: 'Place Your Bets',
        content:
            <div className="rule-content">
                The "BETTING LIMITS" panel displays the minimum and maximum allowed betting limits at the table, which may change from time to time. Open "Betting Limits" to check your current limits.
                <br /><br />
                Ultimate Texas Hold’em 1 - 1 000 $
                <br /><br />
                To participate in the game, you will need sufficient funds to cover your bets. Your current BALANCE is displayed on the screen.
                <br /><br />
                Your funds - BALANCE 100 000 $
                <br /><br />
                The "CHIP DISPLAY" indicator allows you to select the denomination of each chip you wish to place as a bet. Only chips whose denomination can be covered by your current balance are available for selection.
                <br /><br />
                <img className='rule-img' src={`${env.mediapoint}/images/rules/chips.svg`} alt="chips" />
                <br /><br />
                After selecting a chip, place your bet by clicking on the corresponding betting spot on the game table. Each click on a betting spot increases your bet by the value of the selected chip or up to the maximum allowable limit for your chosen bet type. Once the maximum bet limit is placed, additional funds will not be accepted, and a message will appear above your bet notifying you of the maximum bet placement.
                <br />
                <img className='rule-img-big widget' src={`${env.endpoint}/images/rates.png`} alt="bet-ante" />
                <br /><br />
                NOTE: Please do not minimize your browser window or open other browser tabs while the betting time is active and bets are being placed on the table. Such actions may be interpreted as leaving the game, and your bets will be rejected for that round.
                <br /><br />
                The "REPEAT" button allows you to repeat all bets from the previous round. This button remains active until the first chip is placed.
                <br /><br />
                <img className='rule-button-img' src={`${env.mediapoint}/images/rules/repeat.svg`} alt="btn" />
                <br /><br />
                The "DOUBLE" (2×) button becomes available after a bet is placed. Each click will double all your bets up to the maximum limit. Please note that you must have sufficient funds in your account to double ALL of your placed bets.
                <br /><br />
                <img className='rule-button-img' src={`${env.mediapoint}/images/rules/double.svg`} alt="btn" />
                <br /><br />
                The "CANCEL" button allows you to remove the last placed bet.
                <br /><br />
                Clicking the "CANCEL" button again allows you to cancel bets one at a time in the reverse order they were placed. To remove all your bets, hold down the "CANCEL" button.
                <br /><br />
                <img className='rule-button-img' src={`${env.mediapoint}/images/rules/cancel.svg`} alt="btn" />
                <br /><br />
                The "TOTAL BET" indicator displays the total amount of bets placed in the current round.
                <br /><br />
                <img className='rule-img border' src={`${env.mediapoint}/images/rules/totalBet.svg`} alt="total" />
                <br /><br />
                Make Your Decision
                <br /><br />
                After your cards are dealt, your hand combination will appear along with a decision window.
                <br /><br />
                <img className='rule-img-big widget' src={`${env.endpoint}/images/game.webp`} alt="game" />
                <br /><br />
                To move on to the next round, you need to click on the CHECK window.
                <br /><br />
                <img className='rule-img-big' src={`${env.endpoint}/images/check-btn.png`} alt="check" />
                <br /><br />
                You must decide what to press: "BET" to continue the round or "FOLD" to end the round and lose your placed bets.
                <br /><br />
                <img className='rule-img-big' src={`${env.endpoint}/images/bet-pass.png`} alt="btn" />
                <br /><br />
                By clicking the "BET" button, you continue to play and place a "BET." The "BET" will automatically be placed in the "BET" betting spot.
                <br /><br />
                After clicking the "FOLD" button, you will lose your ANTE bet.
                You will be able to observe the game but will not participate in it. To place new bets, you will have to wait for the next round.
                <br />
            </div>

    },
    {
        id: 6,
        title: 'Game Number',
        content:
            <div className="rule-content">
                Each game round is identified by a unique GAME NUMBER.
                <br /><br />
                <img className='rule-img border' src={`${env.endpoint}/images/game-number.png`} alt="number" />
                <br /><br />
                Please use this number (or take a screenshot with the game number) if you wish to contact Customer Support with questions regarding a specific round.
            </div>
    },
    {
        id: 7,
        title: 'Sound',
        content:
            <div className="rule-content">
                The "SOUND" button toggles all game sounds and voices on or off.
                Please note that when switching tables, all sounds will be automatically enabled.
                <br /><br />
                <img className='rule-img' src={`${env.mediapoint}/images/music-on.png`} alt="chips" />
                <br /><br />
                You can change the sound settings by clicking the "SETTINGS" button and selecting the SOUND tab.
            </div>
    },
    {
        id: 8,
        title: 'Game History',
        content:
            <div className="rule-content">
                The "HISTORY" button opens a window displaying all the game rounds you have played and their results.
                <br /><br />
                <img className='rule-img' src={`${env.mediapoint}/images/menu/history.png`} alt="chips" />
                <br /><br />
                You can review your gaming activity through the following:
                <br /><br />
                • ACCOUNT HISTORY - displays the entire history of your account as a list of dates, games, bet amounts, and payouts.
                <br /><br />
                The most recently completed round is displayed at the top of the list.
                <br /><br />
                • GAME HISTORY - clicking on a specific game in the GAME column shows your history related to that game.
            </div>
    },
    {
        id: 9,
        title: 'Actions in Case of Malfunction',
        content:
            <div className="rule-content">
                In case of a game, system, or procedure malfunction, the round is temporarily
                suspended, and the game host informs the service manager. You and
                other players will see a message in the chat or a pop-up notification on the screen stating that the issue is being reviewed. If the manager is able to resolve the error promptly, the game round will resume as usual. If immediate resolution is not possible, the game round is canceled, and the initial bets are refunded to all players who participated in that round.
            </div>
    },
    {
        id: 10,
        title: 'Disconnection Policy',
        content:
            <div className="rule-content">
                If you are disconnected from the game before the betting time expires, any
                bets placed will be deemed invalid and refunded to you. If the disconnection occurs after the betting time has expired, the placed bets will
                remain valid and played without your participation. The results of
                the bet can be viewed in the "History" window after reconnecting.
            </div>
    }
]

export const rules = { ru, en }